import { Component, OnInit } from '@angular/core';

import { MessagingService } from './shared/services/messaging.service';
import { CensoService } from '@app/shared/services/censo.service';

import { Loading } from './shared/models';

import { environment } from '@environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  cliente = environment.cliente;
  message: any;
  carregar = new Loading();

  constructor(
    private messagingService: MessagingService,
    private censoService: CensoService
  ) {
    sessionStorage.clear();
  }

  ngOnInit(): void {
    this.messagingService.requestPermission();
    this.messagingService.receiveMessage();
    this.message = this.messagingService.currentMessage;
    this.buscarCenso();
  }

  buscarCenso(): void {
    if (!this.censoService.retornarSessionStorage('censo')) {
      this.censoService.buscarCenso(this.cliente.censo_id, this.carregar).subscribe(censo => {
        delete(censo.id)
        this.censoService.salvarSessionStorage('censo', censo);
      });
    }
  }
}
